import Repository from "../Repository";
import { getAuthHeader } from "../../_helpers/apiHelper";

const resource = "/tag";

export default {
  get(user) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.get(`${resource}`, config);
  },

  getGotthardp(user) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.get(`${resource}/gotthardp`, config);
  },

  updateTag(user, item) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.post(`${resource}/${item.id}`, item, config);
  }
};
